import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unidades',
  templateUrl: './unidades.component.html',
  styleUrls: ['./unidades.component.scss']
})
export class UnidadesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  unidades: any[] = [
    // {
    //   nome: 'Distrito Federal',
    //   contatos: [
    //     {
    //       icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/endereco.png',
    //       link: 'http://maps.google.com/?q=St Scia Quadra 15, conjunto 3, lote 7 - Guará. Brasília - DF, 71250-015',
    //       descricao: 'St Scia Quadra 15, conjunto 3, lote 7 - Guará. Brasília - DF, 71250-015'
    //     },
    //     {
    //       icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/email.png',
    //       link: 'mailto:ivan.uniondf@gmail.com',
    //       descricao: 'ivan.uniondf@gmail.com'
    //     },
    //     {
    //       icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/telefone.png',
    //       link: 'tel:(61) 99981-0693',
    //       descricao: '(61) 99981-0693'
    //     },
    //     {
    //       icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/whatsapp.png',
    //       link: 'tel:(61) 99981-0693',
    //       descricao: '(61) 99981-0693'
    //     }
    //   ]
    // },
    // {
    //   nome: 'Espírito Santo',
    //   contatos: [
    //     {
    //       icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/endereco.png',
    //       link: 'http://maps.google.com/?q=Av Nossa Senhora da Penha, 1495 – Sala 902 Torre At Edif Corporate Center – Santa Lucia – Vitoria – ES',
    //       descricao: 'Av Nossa Senhora da Penha, 1495 – Sala 902 Torre At Edif Corporate Center – Santa Lucia – Vitoria – ES'
    //     },
    //     {
    //       icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/email.png',
    //       link: 'mailto:diretoria@autopacbrasil.com.br',
    //       descricao: 'diretoria@autopacbrasil.com.br'
    //     },
    //     {
    //       icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/telefone.png',
    //       link: 'tel:(27) 99779-3207',
    //       descricao: '(27) 99779-3207'
    //     },
    //     {
    //       icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/whatsapp.png',
    //       link: 'tel:(27) 99779-3207',
    //       descricao: '(27) 99779-3207'
    //     }
    //   ]
    // },
    {
      nome: 'Espirito Santo',
      contatos: [
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/endereco.png',
          link: 'http://maps.google.com/?q=Rua João Pessoa de Matos, 175 - Centro de Vila Velha, Vila Velha - ES, 29100-560',
          descricao: 'Rua João Pessoa de Matos, 175 - Centro de Vila Velha, Vila Velha - ES, 29100-560'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/email.png',
          link: 'mailto:suporte@unionsolutions.com.br',
          descricao: 'suporte@unionsolutions.com.br'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/telefone.png',
          link: 'tel:(11) 96305-6359',
          descricao: '(11) 96305-6359'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/whatsapp.png',
          link: 'tel:(11) 96305-6359',
          descricao: '(11) 96305-6359'
        }
      ]
    },
    {
      nome: 'Santa Catarina',
      contatos: [
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/endereco.png',
          link: 'http://maps.google.com/?q=Rua Victor Meirelles, 600 - sala 903 Bairro: Campinas Município: São José/SC 88101-170',
          descricao: 'Rua Victor Meirelles, 600 - sala 903 Bairro: Campinas Município: São José/SC 88101-170'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/email.png',
          link: 'mailto:atendimento@unionsul.com.br',
          descricao: 'atendimento@unionsul.com.br'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/telefone.png',
          link: 'tel:(48) 3066-6991',
          descricao: '(48) 3066-6991'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/whatsapp.png',
          link: 'tel:(48) 99161-6991',
          descricao: '(48) 99161-6991'
        }
      ]
    },
    {
      nome: 'Paraná',
      contatos: [
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/endereco.png',
          link: 'http://maps.google.com/?q=R. Conselheiro Laurindo, 825 - Sala 906 - Centro, Curitiba - PR, 80060-100',
          descricao: 'R. Conselheiro Laurindo, 825 - Sala 906 - Centro, Curitiba - PR, 80060-100'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/email.png',
          link: 'mailto:jean@unionsul.com.br',
          descricao: 'jean@unionsul.com.br'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/telefone.png',
          link: 'tel:(41) 9 9273-6551',
          descricao: '(41) 9 9273-6551'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/whatsapp.png',
          link: 'tel:',
          descricao: ''  // Faltando no HTML fornecido
        }
      ]
    },
    {
      nome: 'Minas Gerais',
      contatos: [
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/endereco.png',
          link: 'http://maps.google.com/?q=Al. dos Rouxinóis , 560 Casa 49, Cabral - Contagem CEP: 32146-003',
          descricao: 'Al. dos Rouxinóis , 560 Casa 49, Cabral - Contagem CEP: 32146-003'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/email.png',
          link: 'mailto:contato@unionsolutionsbh.com.br',
          descricao: 'contato@unionsolutionsbh.com.br'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/telefone.png',
          link: 'tel:(31) 3046-5679',
          descricao: '(31) 3046-5679'
        },
        {
          icone: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/12/whatsapp.png',
          link: 'tel:',
          descricao: ''  // Faltando no HTML fornecido
        }
      ]
    }
  ];


}
